/**
 * Shared Firebase app instance.
 *
 * Kept deliberately dependency-light: this module pulls in `firebase/app`
 * ONLY. The heavier products are initialised in sibling modules so the
 * public bundle can load just what it needs:
 *
 *   • firebase/liteDb.js → firestore/lite  (public, read-only pages)
 *   • firebase/config.js → full firestore + storage + auth (admin only)
 */
import { initializeApp, getApps } from 'firebase/app';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// getApps() guard keeps this idempotent when both the lite and the full
// Firestore entry points initialise during the same session.
export const app = getApps()[0] || initializeApp(firebaseConfig);

export default app;
